import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';
import useWindowSize from '@shared/hooks/useWindowsSize';

// Tab personalizado
const AntTab = styled(Tab, {
  shouldForwardProp: prop => prop !== 'antTabSx',
})(({ theme, antTabSx = {} }) => ({
  minHeight: '42px',
  border: '1px solid #636466',
  backgroundColor: '#FFFFFF',
  color: '#636466',
  fontWeight: 600,
  fontSize: '20px',
  lineHeight: 1,
  flex: 1,

  '&:hover': {
    fontWeight: 700,
    color: '#000',
  },

  '&.Mui-selected': {
    backgroundColor: theme.tertiary,
    color: '#FFFFFF',
    border: `1px solid ${theme.tertiary}`,
    '&:hover': {
      fontWeight: 600,
      color: theme.palette.getContrastText(theme.tertiary),
    },
  },

  // MOBILE (↓600px)
  [theme.breakpoints.down('sm')]: {
    fontSize: '18px',
  },

  ...antTabSx,
}));

// Tabs wrapper
const AntTabsWrapper = styled(Tabs)(({ theme }) => ({
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#f3f3f3',
  marginLeft: '20px',
  marginRight: '20px',
  minHeight: '42px',
  [theme.breakpoints.up('lg')]: {
    marginLeft: 0,
    marginRight: 0,
  },
}));

const AntTabs = ({ tabButton, setTabButton, tripLegsLength, search_type }) => {
  const screenSize = useWindowSize();

  const handleTabChange = (_, newValue) => {
    setTabButton(newValue);
  };

  return (
    <AntTabsWrapper value={tabButton} onChange={handleTabChange} centered>
      <AntTab
        sx={{
          fontSize: '18px',
        }}
        label={
          screenSize.width < 540
            ? 'Precios por Aerol.'
            : 'Precios por aerolíneas'
        }
        antTabSx={{
          borderRadius: tripLegsLength <= 2 ? '8px 0 0 0' : '8px 8px 0 0',
        }}
      />

      {tripLegsLength <= 2 && (
        <AntTab
          sx={{
            fontSize: '18px',
          }}
          label={
            screenSize.width < 540 ? 'Personalizada' : 'Búsqueda personalizada'
          }
          antTabSx={{
            borderRadius:
              search_type === 'MultipleFlights'
                ? '0px 8px 0px 0px'
                : '0px 0px 0px 0px',
          }}
        />
      )}

      {search_type !== 'MultipleFlights' && window.vthws && (
        <AntTab
          label={'Precios +/- 3 días'}
          antTabSx={{ borderRadius: '0px 8px 0px 0px' }}
        />
      )}
    </AntTabsWrapper>
  );
};

export default AntTabs;
